import { render, staticRenderFns } from "./SubscriptionStoreField.vue?vue&type=template&id=641b86b5&scoped=true"
import script from "./SubscriptionStoreField.vue?vue&type=script&lang=js"
export * from "./SubscriptionStoreField.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionStoreField.vue?vue&type=style&index=0&id=641b86b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641b86b5",
  null
  
)

export default component.exports